export default __webpack_public_path__ + "static/media/spr-design-system-light-large.3a367c72.png";